import { render } from "./configManagement.vue?vue&type=template&id=6cce8c83&scoped=true"
import script from "./configManagement.vue?vue&type=script&lang=js"
export * from "./configManagement.vue?vue&type=script&lang=js"

import "./configManagement.vue?vue&type=style&index=0&id=6cce8c83&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cce8c83"]])

export default __exports__